import { router } from '@inertiajs/react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

type TabType = 'instagram' | 'messenger' | 'whatsapp'

interface ConnectedAccounts {
  instagram?: string | null
  messenger?: string | null
  whatsapp?: string | null
}

interface MetaTabsProps {
  activeTab: TabType
  businessType?: 'shop' | 'recruiting'
  connectedAccounts?: ConnectedAccounts
}

export function MetaTabs({ activeTab, businessType = 'shop', connectedAccounts }: MetaTabsProps) {
  const handleTabChange = (value: string) => {
    const tab = value as TabType

    // Navigate to the appropriate route based on business type
    if (businessType === 'recruiting') {
      switch (tab) {
        case 'instagram':
          router.visit('/recruiting/messages')
          break
        case 'messenger':
          router.visit('/recruiting/messenger_messages')
          break
        case 'whatsapp':
          router.visit('/whatsapp/recruiting/messages')
          break
      }
    } else {
      switch (tab) {
        case 'instagram':
          router.visit('/instagram/conversations')
          break
        case 'messenger':
          router.visit('/messenger/conversations')
          break
        case 'whatsapp':
          router.visit('/whatsapp/conversations')
          break
      }
    }
  }

  // Get the connected account for the active tab
  const getConnectedAccount = () => {
    if (!connectedAccounts) return null

    switch (activeTab) {
      case 'instagram':
        return connectedAccounts.instagram ? `@${connectedAccounts.instagram}` : null
      case 'messenger':
        return connectedAccounts.messenger || null
      case 'whatsapp':
        return connectedAccounts.whatsapp || null
      default:
        return null
    }
  }

  const connectedAccount = getConnectedAccount()

  return (
    <div>
      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="instagram">Instagram</TabsTrigger>
          <TabsTrigger value="messenger">Messenger</TabsTrigger>
          <TabsTrigger value="whatsapp">WhatsApp</TabsTrigger>
        </TabsList>
      </Tabs>
      {connectedAccount && (
        <div className="mt-3 text-sm text-muted-foreground">
          Connected Account: {connectedAccount}
        </div>
      )}
    </div>
  )
}
